import * as constants from "./constants";

export const fetchReportDetail = (data) => ({
  type: constants.FETCH_REPORT_DETAIL,
  data,
});

export const fetchReportDetailSuccess = (payload) => ({
  type: constants.FETCH_REPORT_DETAIL_SUCCESS,
  payload,
});

export const fetchReportDetailError = (data) => ({
  type: constants.FETCH_REPORT_DETAIL_ERROR,
  data,
});

export const updateReportDetail = (data) => ({
  type: constants.UPDATE_REPORT_DETAIL,
  data,
});

export const updateReportDetailSuccess = (data) => ({
  type: constants.UPDATE_REPORT_DETAIL_SUCCESS,
  data,
});

export const updateReportDetailError = (data) => ({
  type: constants.UPDATE_REPORT_DETAIL_ERROR,
  data,
});

export const createReportDetail = (data) => ({
  type: constants.CREATE_REPORT_DETAIL,
  data,
});

export const createReportDetailSuccess = (payload) => ({
  type: constants.CREATE_REPORT_DETAIL_SUCCESS,
  payload,
});

export const createReportDetailError = (id) => ({
  type: constants.CREATE_REPORT_DETAIL_ERROR,
  id,
});

export const isAddingAction = (data) => ({
  type: constants.IS_ADDING_UPDATE,
  data,
});

export const setStorage = (data) => ({
  type: constants.SET_REPORT_DETAIL_MANAGER_STATE,
  data,
});
